import React from 'react';
import PropTypes from 'prop-types';
import Badge from '@mui/material/Badge';
import IconButton from '@mui/material/IconButton';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';

const Observateurs = ({ count, onClick }) => (
    <IconButton onClick={onClick} size="large">
        <Badge badgeContent={count} color="secondary" overlap="rectangular"><RemoveRedEyeIcon /></Badge>
    </IconButton>
);

Observateurs.propTypes = {
    count: PropTypes.number,
    onClick: PropTypes.func.isRequired
};

export default Observateurs;